export interface Category {
  id: number;
  name: string;
  namePl: string;
  icon: string;
  url: string;
  descriptionPl: string;
}

export const categories: Category[] = [
  {
    id: 1,
    name: "Shoes",
    namePl: "Buty",
    icon: "ri-footprint-line",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    descriptionPl: "Najlepsze sneakersy i obuwie",
  },
  {
    id: 2,
    name: "Hoodies/Sweaters",
    namePl: "Bluzy i Swetry",
    icon: "ri-t-shirt-line",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    descriptionPl: "Ciepłe bluzy i swetry premium",
  },
  {
    id: 3,
    name: "T-Shirts",
    namePl: "T-Shirty",
    icon: "ri-shirt-line",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    descriptionPl: "Koszulki w najlepszych cenach",
  },
  {
    id: 4,
    name: "Jackets",
    namePl: "Kurtki",
    icon: "ri-hail-line",
    url: "https://kaspreadsheet.com/category-914-Jackets.html",
    descriptionPl: "Stylowe kurtki i płaszcze",
  },
  {
    id: 5,
    name: "Pants/Shorts",
    namePl: "Spodnie i Szorty",
    icon: "ri-pantone-line",
    url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    descriptionPl: "Spodnie i szorty na każdą porę",
  },
  {
    id: 6,
    name: "Headwear",
    namePl: "Nakrycia Głowy",
    icon: "ri-customer-service-line",
    url: "https://kaspreadsheet.com/category-916-Headwear.html",
    descriptionPl: "Czapki, kapelusze i akcesoria",
  },
  {
    id: 7,
    name: "Sets",
    namePl: "Zestawy",
    icon: "ri-stack-line",
    url: "https://kaspreadsheet.com/category-917-Sets.html",
    descriptionPl: "Kompletne zestawy ubrań",
  },
  {
    id: 8,
    name: "Underwear/Underpants",
    namePl: "Bielizna",
    icon: "ri-user-heart-line",
    url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html",
    descriptionPl: "Wygodna bielizna codzienna",
  },
  {
    id: 9,
    name: "Jersey",
    namePl: "Koszulki Sportowe",
    icon: "ri-basketball-line",
    url: "https://kaspreadsheet.com/category-919-Jersey.html",
    descriptionPl: "Koszulki sportowe i drużynowe",
  },
  {
    id: 10,
    name: "Accessories",
    namePl: "Akcesoria",
    icon: "ri-vip-diamond-line",
    url: "https://kaspreadsheet.com/category-920-Accessories.html",
    descriptionPl: "Biżuteria i dodatki modowe",
  },
  {
    id: 11,
    name: "Bags",
    namePl: "Torby",
    icon: "ri-shopping-bag-3-line",
    url: "https://kaspreadsheet.com/category-921-Bags.html",
    descriptionPl: "Torby i plecaki w super cenach",
  },
  {
    id: 12,
    name: "Belts",
    namePl: "Paski",
    icon: "ri-links-line",
    url: "https://kaspreadsheet.com/search-922/name/Bags.html",
    descriptionPl: "Stylowe paski i dodatki",
  },
  {
    id: 13,
    name: "Perfumes",
    namePl: "Perfumy",
    icon: "ri-contrast-drop-2-line",
    url: "https://kaspreadsheet.com/search-923/name/Bags.html",
    descriptionPl: "Zapachy premium w niskich cenach",
  },
  {
    id: 14,
    name: "OtherStuff",
    namePl: "Inne Produkty",
    icon: "ri-more-line",
    url: "https://kaspreadsheet.com/search-924/name/Bags.html",
    descriptionPl: "Pozostałe produkty i okazje",
  },
];